import { createSelector } from 'reselect';
 
const selectOneuserSubscriptions = (state: any) => state.oneuserSubscriptions;
 
export const selectOneuserSubscriptionsCurrentItem = createSelector([selectOneuserSubscriptions], (oneuserSubscriptions) => oneuserSubscriptions.current);
 
export const selectOneuserSubscriptionsListItems = createSelector([selectOneuserSubscriptions], (oneuserSubscriptions) => oneuserSubscriptions.list);
 
 
export const selectOneuserSubscriptionsItemById = (itemId: any) =>
    createSelector(selectOneuserSubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectOneuserSubscriptionsQueryItems = createSelector([selectOneuserSubscriptions], (oneuserSubscriptions) => oneuserSubscriptions.query);

export const selectOneuserSubscriptionsCreatedItem = createSelector([selectOneuserSubscriptions], (oneuserSubscriptions) => oneuserSubscriptions.create);
 
export const selectOneuserSubscriptionsUpdatedItem = createSelector([selectOneuserSubscriptions], (oneuserSubscriptions) => oneuserSubscriptions.update);
 
export const selectOneuserSubscriptionsReadItem = createSelector([selectOneuserSubscriptions], (oneuserSubscriptions) => oneuserSubscriptions.read);
 
export const selectOneuserSubscriptionsDeletedItem = createSelector([selectOneuserSubscriptions], (oneuserSubscriptions) => oneuserSubscriptions.delete);
 
export const selectOneuserSubscriptionsSearchedItems = createSelector([selectOneuserSubscriptions], (oneuserSubscriptions) => oneuserSubscriptions.search);
 
export const selectOneuserSubscriptionsItemsCount = createSelector([selectOneuserSubscriptions], (oneuserSubscriptions) => oneuserSubscriptions.count);
 
export const selectOneuserSubscriptionsItemsFilter = createSelector([selectOneuserSubscriptions], (oneuserSubscriptions) => oneuserSubscriptions.filter);